jQuery(function($) {
    $(document).ready( function () {
        let $form = $('form#mc-embedded-subscribe-form');

        if ( $form.length > 0 ) {
            $form.each(function () {
                let currentForm = $(this);
                currentForm.find('input[type="submit"]').bind('click', function (event) {
                    if ( event ) {
                        event.preventDefault();
                    }

                    if ( validate_form(currentForm) ) {
                        register(currentForm);
                    }
                });
            });
        }
    });

    function register($form) {
        let popUp = $('#mailchimp-ty-pop-up');
        let formSpinner = $('.vet-signup-form .vet-spinner');

    	// ajax call
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache       : false,
            dataType    : 'json',
            contentType: 'application/json; charset=utf-8',
            beforeSend : function() {
                formSpinner.addClass('loaded');
            },
            error : function(err) {
                formSpinner.removeClass('loaded');

                alert("Could not connect to the registration server. Please try again later.");
            },
            success : function(data) {
                formSpinner.removeClass('loaded');

                if (data.result === 'success') {
                    if ( data.msg.includes('Jūs jau esat abonējis') ) {
                        popUp.find('.content').addClass('user-exists').removeClass('success error');
                        popUp.addClass('show');
                    } else {
                        popUp.find('.content').addClass('success').removeClass('user-exists error');
                        popUp.addClass('show');

                        // Clear form fields
                        $form.find('.mc-field-group input').val('');
                        $form.find('.mc-field-group input[type="checkbox"]').prop('checked', false);
                    }
                } else {
                    popUp.find('.content').addClass('error').removeClass('user-exists success');
                    popUp.addClass('show');
                }

                // add close events
                function removePopUp (pop) {
                    pop.removeClass('show');
                    pop.find('.content').attr('class','content');
                    pop.off();
                }

                popUp.on('click', '.close, .pop-up-close-button', function () {
                    removePopUp(popUp);
                });

                popUp.on('click', function(event) {
                    if (!$(event.target).closest('#mailchimp-ty-pop-up .container').length) {
                        removePopUp(popUp);
                    }
                });
            }
        });
    }

    function validate_form($form) {
        let validated = true;

        /* Handle email input validation */
        // Regular expression for email validation
        let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        $form.find('input[type="email"][aria-required="true"]').each(function () {
            if ( $(this).val() === '' ) {
                error_el($(this), form_texts.empty);
                validated = false;
            } else if ( !regex.test($(this).val()) ) {
                error_el($(this), form_texts.invalid_email);
                validated = false;
            } else {
                clear_error($(this));
            }
        });

        $form.find('input[type="checkbox"][aria-required="true"]').each(function () {
            if ( $(this).is(':checked') ) {
                if ( $(this).parent().hasClass('switch') ) {
                    clear_error( $(this).parent() );
                } else {
                    clear_error( $(this) );
                }
            } else {
                if ( $(this).parent().hasClass('switch') ) {
                    error_el( $(this).parent(), form_texts.empty );
                } else {
                    error_el( $(this), form_texts.empty );
                }

                validated = false;
            }
        });

        /* Handle select field validation */
        // let select = $form.find('select');
        // if ( select.find('option:selected').prop('disabled') === true ) {
        //     error_el(select, form_texts.empty);
        //     validated = false;
        // } else {
        //     clear_error(select);
        // }

        return validated;
    }

    /* Error functions */
    function error_el(elem, msg) {
        let error_HTML = '<span class="error-msg">' + msg + '</span>';

        if ( elem.parent().hasClass('has-error') ) {
            elem.parent().find('.error-msg').remove();
        }

        elem.attr('aria-invalid', true);
        elem.parent().addClass('has-error');
        elem.parent().removeClass('validated');
        elem.after(error_HTML);
    }

    function clear_error(elem) {
        elem.attr('aria-invalid', false);
        elem.parent().removeClass('has-error');
        elem.parent().addClass('validated');
        elem.parent().find('.error-msg').remove();
    }
});